import { MDXRemote, MDXRemoteSerializeResult } from "next-mdx-remote";

import CustomMDXLink from "./CustomMDXLink";

/**
 * The MDX renderer for CMS rich text.
 *
 * ⭐ PORTFOLIO-CANONICAL COPY (owner, 2026-09-07) — reused from
 * av-sweetandbitter-web's CustomMDXRemote with the same API (ContainerType,
 * anchorListItemsAs) so section implementations and CMS content conventions
 * move between projects unchanged. Per-project part: the container-class
 * mapping below — S&B maps the types to its typography CSS modules, this
 * design system has ONE prose rhythm, so everything except "Plain" maps to
 * `.prose-content`. anchorListItemsAs has no caller here yet; it exists for
 * S&B's HowToStep structured data and stays for API parity.
 */
type ContainerType =
  | "TextContainer" | "LinkContainer" | "LongTextContainer"
  | "NoLinkStylesContainer" | "Plain";

const getTextContainerClass = (typeOfContainer?: ContainerType) =>
  typeOfContainer === "Plain" ? "" : "prose-content";

const CustomMDXRemote = (props: {
  content?: MDXRemoteSerializeResult;
  className?: string;
  typeOfContainer?: ContainerType;
  anchorListItemsAs?: string;
}) => {
  if (!props.content) {
    return null;
  }
  const textContainerClass = getTextContainerClass(props.typeOfContainer);

  // anchorListItemsAs numbers every rendered <li> so structured data can
  // link to a single step. Per-render counter, document order (S&B).
  let itemIndex = 0;
  const components = props.anchorListItemsAs
    ? {
        a: CustomMDXLink,
        li: (liProps: React.ComponentProps<"li">) => (
          <li id={`${props.anchorListItemsAs}${++itemIndex}`} {...liProps} />
        ),
      }
    : { a: CustomMDXLink };

  return (
    <div className={`${textContainerClass} ${props.className ?? ""}`}>
      <MDXRemote {...props.content} components={components} />
    </div>
  );
};

export default CustomMDXRemote;
